import React from 'react';

const Button = (props) => {
    let {className, onClick, disabled=false} = props
    return (
        <button className={`btn w-100 py-2 ${className||'auth_btn'}`} disabled={disabled} onClick={onClick}>{props.children}</button>
    );
};

export default Button;